import { Controller } from "@hotwired/stimulus"

// Copies a hidden textarea's full value to the clipboard and briefly confirms it worked, so a
// postmortem can be pasted straight into Slack/a doc without needing to select-and-copy by hand.
export default class extends Controller {
  static targets = ["source", "button"]

  copy() {
    navigator.clipboard.writeText(this.sourceTarget.value).then(() => {
      const original = this.buttonTarget.textContent
      this.buttonTarget.textContent = "Copied!"
      setTimeout(() => { this.buttonTarget.textContent = original }, 2000)
    })
  }
}
